import { render, staticRenderFns } from "./FlaggingRightSideMenu.vue?vue&type=template&id=7419ad98&scoped=true"
import script from "./FlaggingRightSideMenu.vue?vue&type=script&lang=js"
export * from "./FlaggingRightSideMenu.vue?vue&type=script&lang=js"
import style0 from "./FlaggingRightSideMenu.vue?vue&type=style&index=0&id=7419ad98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7419ad98",
  null
  
)

export default component.exports